import clsx from 'clsx';
import type { MouseEvent, ReactNode } from 'react';
import Button from 'react-bootstrap/Button';
import { BsPlusLg } from 'react-icons/bs';
import type { Placement } from 'react-bootstrap/types';

import BayTooltip from '../BayTooltip';

import './BayAddButton.scss';

interface BayAddButtonProps {
	size?: 'sm' | 'lg' | null;
	onlyIcon?: boolean;
	disabled?: boolean;
	onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
	className?: string | null;
	showTooltip?: boolean;
	tooltipPlacement?: Placement;
	variant?: string;
	overlay?: string;
	overlayWidth?: number | string;
	text?: string;
	showIcon?: boolean;
	children?: ReactNode | null;
}

const BayAddButton = ({
	size = null,
	onlyIcon = false,
	disabled = false,
	onClick,
	className = null,
	showTooltip = false,
	tooltipPlacement = 'top',
	variant = 'primary',
	overlay ='',
	overlayWidth,
	text = 'Add',
	showIcon = true,
	children = null,
}: BayAddButtonProps) => {
	const onClickHandler = (e: MouseEvent<HTMLButtonElement>) => {
		if (disabled) {
			e.preventDefault();
			return;
		}

		if (onClick) {
			return onClick(e);
		}
	};

	const classes = clsx([
		'bay-add-button',
		'd-flex',
		'align-items-center',
		onlyIcon && size !== 'sm'
			? 'px-2'
			: onlyIcon && size === 'sm'
				? 'px-1'
				: null,
		className,
		disabled ? 'disabled' : null,
	]);

	const ButtonText = ({ onlyIcon, showIcon, text }: { onlyIcon: boolean; showIcon: boolean; text: string }) => {
		return (
			<>
				{showIcon && <BsPlusLg className={!onlyIcon && text ? 'me-1' : ''} />}
				{!onlyIcon && text && <>{text}</>}
			</>
		);
	};

	return !showTooltip ? (
		<Button
			className={classes}
			disabled={disabled}
			size={size ?? undefined}
			variant={variant}
			onClick={onClickHandler}
		>
			{children ? (
				children
			) : (
				<ButtonText onlyIcon={onlyIcon} showIcon={showIcon} text={text} />
			)}
		</Button>
	) : (
		<BayTooltip
			placement={tooltipPlacement}
			overlay={overlay ?? ''}
			{...(overlayWidth != null ? { overlayWidth } : {})}
			overlayClassName=""
			inverseStyle={false}
		>
			<span>
				<Button
					className={classes}
					disabled={disabled}
					size={size ?? undefined}
					variant={variant}
					onClick={onClickHandler}
				>
					{children ? (
						children
					) : (
						<ButtonText onlyIcon={onlyIcon} showIcon={showIcon} text={text} />
					)}
				</Button>
			</span>
		</BayTooltip>
	);
};

export default BayAddButton;
